import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';
import SideNavigation from 'containers/SideNavigation/sideNavigation';
import cx from 'classnames';
import styled from 'styled-components';
import { useAuthStore } from 'stores/authStore';
export const LayoutContext = createContext();

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const MainContentWrapper = styled.div`
  flex: 1;
  min-height: 0;
`;

const Layout = ({ children }) => {
  const [compact, setCompact] = useState(false);
  const isUserLoggedIn = useAuthStore((state) => !!state.user);

  return (
    <LayoutContext.Provider
      value={{
        sideBarCollapsed: compact,
      }}
    >
      <PageWrapper>
        {isUserLoggedIn ? <SideNavigation compact={compact} toggleNavigation={setCompact} /> : null}
        <MainContentWrapper className={cx('main-content', { collapsed: compact })}>
          {children}
        </MainContentWrapper>
      </PageWrapper>
    </LayoutContext.Provider>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
